import { makeStyles } from "tss-react/mui";
import {
  DocumentPreview,
  MiButton,
  MiIcon,
  MiIconButton,
  MiStackedTypography,
} from "@miplatform/components";
import {
  BUTTON_COLORS,
  DATE_TIME_FORMATS,
  ICONS_WEB,
  PERMISSIONS,
} from "@miplatform/constants";
import { formatDate, getCurrencyString } from "@miplatform/utils";
import * as mdi from "@mdi/js";
import { usePermissions } from "@mibuildweb/hooks";
import { Box } from "@mui/material";

export const BackchargeDetails = ({ backcharge, onBack, onEdit, onDelete }) => {
  const { classes } = useStyles();
  const { hasPermission } = usePermissions();
  const canUpdate = hasPermission(PERMISSIONS.CREDIT_MEMO.UPDATE);
  const canDelete = hasPermission(PERMISSIONS.CREDIT_MEMO.VOID);

  return (
    <>
      <Box display="flex" justifyContent="space-between" p={2} pt={1} mb={2}>
        <Box display="flex" gap={4} flexWrap="wrap">
          <MiButton
            variant="text"
            size="small"
            color={BUTTON_COLORS.GREY}
            startIcon={{ path: mdi[ICONS_WEB.ARROW_LEFT] }}
            onClick={onBack}
          />
          <MiStackedTypography
            title="Date Added"
            description={formatDate(
              backcharge?.date,
              DATE_TIME_FORMATS.FORMAT_MM_DD_YY
            )}
            descriptionProps={{
              className: classes.fieldDescription,
            }}
          />
          <MiStackedTypography
            title="PO Number"
            description={backcharge?.poNumber}
            descriptionProps={{
              className: classes.fieldDescription,
            }}
          />
          <MiStackedTypography
            title="Amount"
            description={getCurrencyString(backcharge?.amount)}
            descriptionProps={{
              className: classes.fieldDescription,
              color: "red.main",
            }}
          />
        </Box>
        <Box display="flex" alignItems="center">
          <MiIconButton
            disabled={!canUpdate}
            onClick={() => onEdit(backcharge)}
          >
            <MiIcon path={mdi[ICONS_WEB.PENCIL_OUTLINE]} />
          </MiIconButton>

          <MiIconButton
            disabled={!canDelete}
            onClick={() => onDelete(backcharge)}
          >
            <MiIcon path={mdi[ICONS_WEB.CANCEL]} />
          </MiIconButton>
        </Box>
      </Box>
      <DocumentPreview selectedDocument={backcharge?.document} />
    </>
  );
};

const useStyles = makeStyles()((theme) => ({
  fieldDescription: {
    maxWidth: 110,
    fontWeight: theme.fontWeight.bold,
  },
}));
